<div class="min-h-screen bg-gray-50 pb-12">
  <header class="bg-white border-b border-gray-200">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <nav class="flex py-4" aria-label="Breadcrumb">
        <ol class="flex items-center space-x-2 text-sm text-gray-500">
          <li>
            <a routerLink="/" class="hover:text-blue-600 transition-colors">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
              </svg>
            </a>
          </li>
          <li class="flex items-center text-blue-600 font-medium">
            <span class="mx-2 text-gray-300">/</span>
            <span>Panel de control</span>
          </li>
        </ol>
      </nav>

      <div class="pb-6 md:flex md:items-center md:justify-between">
        <div class="flex-1 min-w-0">
          <h1 class="text-2xl font-bold text-gray-900 sm:text-3xl">Panel de control</h1>
          <p class="text-sm text-slate-500 mt-1">Resumen del estado del inventario</p>
        </div>
        <div class="mt-4 flex gap-3 md:mt-0 md:ml-4">
          <button (click)="loadDashboard()"
            class="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 shadow-sm transition-all">
            <svg class="mr-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
            </svg>
            Actualizar
          </button>
        </div>
      </div>
    </div>
  </header>

  <main class="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
    <!-- Loading -->
    @if (loading()) {
      <div class="flex items-center justify-center py-12">
        <svg class="animate-spin h-10 w-10 text-blue-600" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
        </svg>
      </div>
    } @else if (error()) {
      <div class="bg-red-50 border border-red-200 rounded-xl p-8 text-center">
        <svg class="w-12 h-12 text-red-400 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"/>
        </svg>
        <p class="text-red-700 font-medium">{{ error() }}</p>
        <button (click)="loadDashboard()" class="mt-4 px-4 py-2 bg-red-600 text-white font-bold rounded-lg hover:bg-red-700 transition-colors">
          Reintentar
        </button>
      </div>
    } @else {
      <!-- KPI Cards -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        <!-- Materiales Criticos -->
        <div class="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm font-medium text-slate-500">Materiales en Estado Critico</p>
              <p class="text-3xl font-bold text-red-600 mt-2">{{ summary()?.materiales_criticos || 0 }}</p>
              <p class="text-xs text-slate-400 mt-1">Stock igual o menor al minimo</p>
            </div>
            <div class="w-14 h-14 bg-red-100 rounded-full flex items-center justify-center">
              <svg class="w-7 h-7 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"/>
              </svg>
            </div>
          </div>
        </div>

        <!-- Equipos No Devueltos -->
        <div class="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm font-medium text-slate-500">Equipos Pendientes de Devolucion</p>
              <p class="text-3xl font-bold text-amber-600 mt-2">{{ summary()?.equipos_no_devueltos || 0 }}</p>
              <p class="text-xs text-slate-400 mt-1">Entregados hace mas de 5 dias</p>
            </div>
            <div class="w-14 h-14 bg-amber-100 rounded-full flex items-center justify-center">
              <svg class="w-7 h-7 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
            </div>
          </div>
        </div>
      </div>

      <!-- Listados -->
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <!-- Materiales Criticos List -->
        <div class="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
          <div class="bg-red-50 px-6 py-4 border-b border-red-100">
            <h3 class="text-sm font-bold text-red-800 flex items-center gap-2">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
              </svg>
              Materiales en Estado Critico
            </h3>
          </div>

          @if (materialesCriticos().length === 0) {
            <div class="p-8 text-center">
              <svg class="w-12 h-12 text-green-400 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <p class="text-slate-500">No hay materiales en estado critico</p>
            </div>
          } @else {
            <div class="divide-y divide-slate-100">
              @for (material of materialesCriticos(); track material.id) {
                <div class="px-6 py-4 hover:bg-red-50 cursor-pointer transition-colors" (click)="verMaterial(material.id)">
                  <div class="flex items-center justify-between">
                    <div class="flex-1 min-w-0">
                      <p class="text-sm font-medium text-slate-800 truncate">{{ material.nombre }}</p>
                      <div class="flex items-center gap-2 mt-1">
                        @if (material.tipo_presentacion) {
                          <span class="text-xs text-slate-500">{{ material.tipo_presentacion }}</span>
                        }
                        @if (material.ubicacion) {
                          <span class="text-xs text-slate-400">{{ material.ubicacion }}</span>
                        }
                      </div>
                    </div>
                    <div class="flex items-center gap-3 ml-4">
                      <div class="text-right">
                        <p class="text-sm font-bold text-red-600">{{ material.stock }}</p>
                        <p class="text-xs text-slate-400">min: {{ material.stock_minimo }}</p>
                      </div>
                      <svg class="w-5 h-5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                      </svg>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>

        <!-- Equipos No Devueltos List -->
        <div class="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
          <div class="bg-amber-50 px-6 py-4 border-b border-amber-100">
            <h3 class="text-sm font-bold text-amber-800 flex items-center gap-2">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
              </svg>
              Equipos Pendientes de Devolucion
            </h3>
          </div>

          @if (equiposNoDevueltos().length === 0) {
            <div class="p-8 text-center">
              <svg class="w-12 h-12 text-green-400 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <p class="text-slate-500">No hay equipos pendientes de devolucion</p>
            </div>
          } @else {
            <div class="divide-y divide-slate-100">
              @for (equipo of equiposNoDevueltos(); track equipo.id) {
                <div class="px-6 py-4 hover:bg-amber-50 cursor-pointer transition-colors" (click)="verPedido(equipo.pedido_id)">
                  <div class="flex items-start justify-between">
                    <div class="flex-1 min-w-0">
                      <p class="text-sm font-medium text-slate-800 truncate">{{ equipo.nombre }}</p>
                      <div class="flex items-center gap-2 mt-1">
                        @if (equipo.codigo_patrimonio) {
                          <span class="text-xs font-mono text-slate-500">{{ equipo.codigo_patrimonio }}</span>
                        }
                        @if (equipo.marca) {
                          <span class="text-xs text-slate-400">{{ equipo.marca }}</span>
                        }
                      </div>
                      <div class="mt-2">
                        <p class="text-xs text-slate-500">
                          <span class="font-medium">Pedido:</span>
                          <span class="font-mono">{{ equipo.pedido_codigo }}</span>
                        </p>
                        @if (equipo.solicitante_nombre) {
                          <p class="text-xs text-slate-400">{{ equipo.solicitante_nombre }}</p>
                        }
                      </div>
                    </div>
                    <div class="flex items-center gap-3 ml-4">
                      <div class="text-right">
                        <p class="text-sm font-bold text-amber-600">{{ equipo.dias_sin_devolver }} dias</p>
                        <p class="text-xs text-slate-400">{{ equipo.fecha_entrega | date:'dd/MM/yyyy' }}</p>
                      </div>
                      <svg class="w-5 h-5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                      </svg>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </main>
</div>
